import { View } from "@react-pdf/renderer";
import React from "react";
import { Heading } from "../heading";
import { Spacer } from "../spacer";
import { Text } from "../text";

export function Signature() {
	return (
		<React.Fragment>
			<View
				wrap={false}
				style={{
					marginTop: "auto",
					paddingTop: "0.5cm",
				}}
			>
				<Text>Dieses Schreiben wurde maschinell erstellt und ist ohne Unterschrift gültig.</Text>
				<Spacer />
				<Heading>Florian Pürschel</Heading>
			</View>
		</React.Fragment>
	);
}
